import { render, staticRenderFns } from "./classStudentsImport.vue?vue&type=template&id=00e517a6&scoped=true&"
import script from "./classStudentsImport.vue?vue&type=script&lang=js&"
export * from "./classStudentsImport.vue?vue&type=script&lang=js&"
import style0 from "./classStudentsImport.vue?vue&type=style&index=0&id=00e517a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e517a6",
  null
  
)

export default component.exports